import styled from 'styled-components';

const BaseContainer = styled.div`
	max-width: 940px;
`;

export default BaseContainer;


// WEBPACK FOOTER //
// ./src/ui/BaseContainer.js